import { useSignInPage } from "./logic";
import { SignInPageTemplate } from "./template";

export const SignInPage = (): JSX.Element => {
  const data = useSignInPage();
  return <SignInPageTemplate {...data} />;
};
